
import {initWebComponent} from "@/helpers/web-component-helper";
import {initHideButton, showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper";
import {
    clearInfoCharacteristics,
    isInfoCharacteristicsLoaded
} from "@/helpers/layer/info/layer-info-characteristics-helper";

export class LayerInfoCharacteristicsButtonComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `<layer-info-button data-icon="fa fa-tag" data-title="characteristics"></layer-info-button>`;

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            if(!isInfoCharacteristicsLoaded()) {
                clearInfoCharacteristics()
            }
            showLayerInfoButton('layer-info-characteristics')
            initHideButton()
        })
    }
}

